import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { isRefiQualifiedWithMinimumPayments } from '../../utils/app_data';

/**
 * Ask estimate mileage of the car.
 */
export const EstimatedMileageStep: Step = {
  id: 'estimatedMileage',
  pathname: '/estimatedmileage',

  canShow: (appData) => {
    // Don't ask if user did not select insurance service.
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    // Only show if user is disqualified for refi and user has min number of car loan payments.
    return !!appData.selectedService?.refi && isRefiQualifiedWithMinimumPayments(appData);
  },
  hasData: () => true,
  hasOwnData: (appData) => true,
  category: () => StepCategory.Other,
};
